import { stringToElements } from '../helpers/index.js';
import { getOpenWalletLink } from '../pricing/links.js';
import { ddcLog } from '../utils/logger.js';

// Insert the My Wallet header icon / toolbar content.
export const insertHeaderWallet = (isMobile, iconConfig) => {
	const region = document.querySelector('[data-location="header-toolbar"]') ||
			       document.querySelector('#header-toolbar');
	if (!region) {
		ddcLog('HeaderWallet -> header-toolbar region not found');
		return;
	}

	if (region.querySelector('[data-mywallet-header]')) {
		ddcLog('HeaderWallet -> already inserted, skipping');
		return;
	}

	// Simplified icon resolution: only accept non-empty strings; fallback to 'mywallet'.
	const iconClass = (typeof iconConfig === 'string' && iconConfig.trim()) ? iconConfig.trim() : 'mywallet';

	if (isMobile) {
		const walletIconTemplate = [
			'<i class="ddc-icon-',
			iconClass,
			' ddc-icon ddc-nav-icon" aria-hidden="true" title="myWallet" role="presentation" tabindex="-1"></i>'
		].join('');
		const walletIconEle = stringToElements(walletIconTemplate);
		const openMobileWalletLink = getOpenWalletLink(
			null,
			'btn btn-default ddc-btn-nav btn-no-decoration btn-unstyled border-0 w-100',
			false,
			false,
			null,
			'budget'
		);
		openMobileWalletLink.setAttribute('data-mywallet-header', 'true');
		openMobileWalletLink.appendChild(walletIconEle);
		region.appendChild(openMobileWalletLink);

		const headerToolbarEle = region.parentElement;
		if (headerToolbarEle) {
			headerToolbarEle.classList.add('ddc-btn-nav');
		}
	} else {
		const desktopHeaderTemplate = [
			'<div class="show-true toolbar-open toolbar-white  ddc-toolbar logged-out">',
			'<div class="toolbar-flex">',
			'<div class="mycars has-digital-retailing mycars-integration-navbar border-left-0">',
			'<div class="size-360-auto menu menu-show float-left wallet-link"></div>',
			'</div>',
			'</div>',
			'</div>'
		].join('');
		const markup = stringToElements(desktopHeaderTemplate);
		const openDesktopWalletLink = getOpenWalletLink(null, `ddc-icon-${iconClass} ddc-icon ddc-nav-icon`, false, false, null, 'budget');
		openDesktopWalletLink.setAttribute('data-mywallet-header', 'true');
		markup.querySelector('.wallet-link').append(openDesktopWalletLink);
		region.appendChild(markup);
	}

	ddcLog(`HeaderWallet -> insertion complete (iconClass='${iconClass}')`);
};
